module.exports = __webpack_public_path__ + "media/mallet.fa5042f9.ogg";